'use strict';
var twentyninetimes = twentyninetimes || {};

twentyninetimes.testimonials = twentyninetimes.testimonials || function () {

	function init() {
		let testimonial_sliders = document.querySelectorAll('.js-testimonial-slider');

		if ( testimonial_sliders ) {
			createTestimonialSliders(testimonial_sliders);
		}
	}

	function createTestimonialSliders(testimonial_sliders) {
		testimonial_sliders.forEach(slider => {
			const sliderItems = slider.querySelectorAll('.js-item-testimonial');

			var initialIndex = sliderItems.lenght > 2 ? 1 : 0;

		    let flkty = new Flickity( slider, {
				// options
				initialIndex: initialIndex,
				imagesLoaded: true,
                cellAlign: 'left',
				wrapAround: true,
                pageDots: false,
				prevNextButtons: true,
				on: {
					ready: function() {
						this.resize();
					}
				}
		    });

		    slider.addEventListener('click', function(e) {
		        e.stopPropagation();

		        let slide       = event.target.closest('.js-item-testimonial'),
		            slide_index = slide.getAttribute('data-index');

		        flkty.select( slide_index, true, false );
		    });

		    flkty.on( 'change', function( index ) {
		        var iframe_slide = slider.querySelector('.js-item-testimonial.has-iframe'),
		        	comparisonSlide = slider.querySelectorAll('.js-item-testimonial.has-comparison0');

		        if ( iframe_slide ) {
		            iframe_slide.classList.remove('has-iframe', 'oembed-active');

		            var iframe = iframe_slide.querySelector('.video-embed-wrapper');
		            if ( !iframe ) return;

		            setTimeout(function() {
		                iframe_slide.removeChild(iframe);
		            }, 600);
		        }
		    });
		});
	}

	return {
		init : init
	};

}();